import "./color.css";
import "./fancybox.css";
import "./flaticon.css";
import "./plugin.css";
import "./slick-slider.css";
import "./style.css";
import "./careerfy.css"
import "./responsive.css"


// WEBPACK FOOTER //
// ./src/styles/job-list/index.js